export var customerId = function customerId(state) {
  return state.customer && state.customer.params ? state.customer.params.id : null;
};